import { render, staticRenderFns } from "./confirmDeletionTemplateModal.vue?vue&type=template&id=57c73872&"
import script from "./confirmDeletionTemplateModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports